module.exports = __webpack_public_path__ + "static/media/dot-icon.c8ca6864.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/dot-icon.svg
// module id = 428
// module chunks = 0